import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sm:w-2/3 flex flex-col mx-[48px] mt-[30px] sm:mt-0 sm:ml-[50px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg text-gary-text-color" }, "基本設定", -1)
const _hoisted_3 = { class: "flex flex-col sm:flex-row mt-3" }
const _hoisted_4 = { class: "flex sm:w-[360px] sm:mr-[114px] flex-col mt-2" }
const _hoisted_5 = { class: "mb-5 text-sm text-breadcrumb-color tracking-[.06em] font-light" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 會員帳號（手機號碼） ")
const _hoisted_7 = { class: "pt-2 font-normal text-light-gary-text-color text-[13px] tracking-[.12em]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sm:w-[380px] mb-[20px] sm:mb-[40px] font-light text-xs sm:text-sm text-breadcrumb-color tracking-[.06em]" }, " 訂單及發票相關資訊將會發送至此電子信箱，請確認資料的正確性。 ", -1)
const _hoisted_9 = { class: "grow flex flex-col text-xs font-light flex-1" }
const _hoisted_10 = { class: "text-sm mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "input-label relative font-light pb-2 text-breadcrumb-color tracking-widest" }, " 生日 ", -1)
const _hoisted_12 = { class: "text-sm mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-label relative font-light pb-2 text-breadcrumb-color tracking-widest" }, " 性別 ", -1)
const _hoisted_14 = { class: "sm:w-[300px] pt-[20px] sm:pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_AddressInput = _resolveComponent("AddressInput")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.store.state.userInfo.Mobile), 1)
        ]),
        _createVNode(_component_Input, {
          label: '姓名',
          class: "under-line mb-5",
          width: '100%',
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "請輸入您的姓名"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Input, {
          label: 'Email',
          class: "under-line mb-5",
          width: '100%',
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
          placeholder: "請輸入email"
        }, null, 8, ["modelValue"]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_AddressInput, {
          deliveryAddr: _ctx.contactAddr,
          "onUpdate:deliveryAddr": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactAddr) = $event)),
          deliveryCity: _ctx.contactCity,
          "onUpdate:deliveryCity": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactCity) = $event)),
          deliveryDist: _ctx.contactDist,
          "onUpdate:deliveryDist": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactDist) = $event)),
          deliveryZip: _ctx.contactZip,
          "onUpdate:deliveryZip": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contactZip) = $event)),
          label: '地址'
        }, null, 8, ["deliveryAddr", "deliveryCity", "deliveryDist", "deliveryZip"]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_date_picker, {
            class: "w-full",
            "prefix-class": "xmx",
            valueType: "format",
            value: _ctx.timeRange,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.timeRange) = $event)),
            "disabled-date": _ctx.disabledAfterToday,
            clearable: false,
            placeholder: '請選擇日期'
          }, null, 8, ["value", "disabled-date"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_Select, {
            class: "my-3 w-full",
            width: '100%',
            itemList: _ctx.store.state.userInfo.GenderList,
            itemValue: 'Code',
            itemText: 'Desc',
            modelValue: _ctx.gender,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gender) = $event))
          }, null, 8, ["itemList", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Btn, {
        text: '更新',
        height: '40px',
        width: '100%',
        onClick: _ctx.changeUserInfo
      }, null, 8, ["onClick"])
    ])
  ]))
}